import { Minus, Plus, X } from "lucide-react";
import { Link } from "react-router-dom";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "../components/ui/sheet";
import { useCart } from "../context/CartContext";

export default function CartDrawer() {
  const { items, isOpen, setIsOpen, removeItem, updateQuantity, totalPrice } = useCart();

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetContent data-testid="cart-drawer" className="w-full sm:max-w-md flex flex-col bg-white p-0">
        <SheetHeader className="px-6 py-5 border-b border-[#E5E5E5]">
          <SheetTitle className="text-lg tracking-[0.1em] uppercase text-[#0A0A0A]">
            Pre-Order ({items.length})
          </SheetTitle>
          <SheetDescription className="sr-only">Your pre-order items</SheetDescription>
        </SheetHeader>

        {items.length === 0 ? (
          <div data-testid="cart-empty" className="flex-1 flex flex-col items-center justify-center px-6">
            <p className="text-[#888] text-sm tracking-wide mb-6">Your pre-order is empty</p>
            <button onClick={() => setIsOpen(false)}
              className="bg-[#0A0A0A] text-white px-8 py-3 text-xs tracking-[0.2em] uppercase hover:bg-[#1a1a1a] transition-colors"
              style={{ fontStyle: "normal" }}>
              Continue Shopping
            </button>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto px-6 py-4 space-y-6">
              {items.map((item) => (
                <div key={`${item.product_id}-${item.size}`} data-testid="cart-item" className="flex gap-4">
                  <div className="w-20 h-24 bg-[#F3F3F3] flex-shrink-0 overflow-hidden">
                    <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex justify-between items-start">
                      <div>
                        <p className="text-sm text-[#0A0A0A] leading-snug truncate pr-2">{item.name}</p>
                        <p className="text-xs text-[#888] mt-1" style={{ fontStyle: "normal" }}>Size: {item.size}</p>
                      </div>
                      <button data-testid="cart-remove-item"
                        onClick={() => removeItem(item.product_id, item.size)}
                        className="text-[#888] hover:text-[#0A0A0A] transition-colors">
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                    <div className="flex items-center justify-between mt-3">
                      <div className="flex items-center border border-[#E5E5E5]">
                        <button data-testid="cart-decrease-qty"
                          onClick={() => updateQuantity(item.product_id, item.size, item.quantity - 1)}
                          className="w-8 h-8 flex items-center justify-center hover:bg-[#F3F3F3] transition-colors">
                          <Minus className="w-3 h-3" />
                        </button>
                        <span className="w-8 h-8 flex items-center justify-center text-xs border-x border-[#E5E5E5]"
                          style={{ fontStyle: "normal" }}>{item.quantity}</span>
                        <button data-testid="cart-increase-qty"
                          onClick={() => updateQuantity(item.product_id, item.size, item.quantity + 1)}
                          className="w-8 h-8 flex items-center justify-center hover:bg-[#F3F3F3] transition-colors">
                          <Plus className="w-3 h-3" />
                        </button>
                      </div>
                      <span className="text-sm text-[#0A0A0A]" style={{ fontStyle: "normal" }}>
                        CHF {(item.price * item.quantity).toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="border-t border-[#E5E5E5] px-6 py-5 space-y-4">
              <div className="flex justify-between items-center">
                <span className="text-sm tracking-[0.1em] uppercase text-[#888]">Total</span>
                <span className="text-lg text-[#0A0A0A]" data-testid="cart-total" style={{ fontStyle: "normal" }}>
                  CHF {totalPrice.toFixed(2)}
                </span>
              </div>
              <Link to="/checkout" onClick={() => setIsOpen(false)}
                data-testid="checkout-button"
                className="block w-full bg-[#8B6F47] text-white py-4 text-xs tracking-[0.2em] uppercase text-center hover:bg-[#7A6140] transition-colors active:scale-[0.98]"
                style={{ fontStyle: "normal" }}>
                Proceed to Pre-Order Checkout
              </Link>
              <p className="text-center text-[10px] text-[#888] tracking-wide" style={{ fontStyle: "normal" }}>
                No payment required now
              </p>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
}
